<template>
  <div
    class="col-12 col-md-2 text-center position-relative">
    <Indicator :product="product"/>
    <img
      class="img-fluid mt-4"
      style="max-height: 100px; max-height: 100px; object-fit: contain;"
      :src="product.image_url"
      @error="imgError">
  </div>
  <div class="col-12 col-md-3">
    <ProductPrice
      :product="product"
      @activeUom="setActiveUom"/>
    <QtyBreaks :product="product"/>
    {{product.description}}
    <ul
      class="text-muted"
      style="list-style-type: none; padding: 0px; font-size:12px;">
      <li>Product ID: {{product.product_id}}</li>
      <li>UPC: {{product.upc}}</li>
      <li>Case Qty: {{caseQty}}</li>
      <li v-if="product.customer_part_number">Part Number: {{ product.customer_part_number.part_number }}</li>
    </ul>
  </div>
  <div class="col-12 col-md-5">
    <Availability
      class="shadow-sm"
      :product="product"
      :activeUom="activeUom"/>
  </div>
  <div class="col-12 col-md-2 text-center">
    <QtyForm
      class="mt-2"
      :product="product"
      :activeUom="activeUom"/>
  </div>
</template>

<script>
  import {caseQuantity} from '../../../../shared/ProductFunctions'
  import comingSoon from '../../../../shared/comingSoon'
  import Availability from '../product/detail/Availability.vue'
  import Indicator from '../product/Indicator.vue'
  import ProductPrice from '../product/price/ProductPrice.vue'
  import QtyBreaks from '../product/QtyBreaks.vue'
  import QtyForm from '../product/QtyForm.vue'

  export default{
    props:['product'],
    data(){
      return{
        activeUom: null
      }
    },
    components:{
      Availability,
      Indicator,
      ProductPrice,
      QtyBreaks,
      QtyForm
    },
    methods:{
      imgError(e){comingSoon(e)},
      setActiveUom(activeUom){this.activeUom = activeUom},
    },
    computed:{
      caseQty(){return caseQuantity(this.product)},
      hidePricing(){return this.$store.getters.hidePricing}
    }
  }
</script>